import useAnimCounter from '../hooks/useAnimCounter';

/**
 * Animated number counter that starts when scrolled into view.
 * Props: end, suffix, prefix, duration
 */
export default function AnimCounter({ end, suffix = '', prefix = '', duration = 2000 }) {
  const [value, ref] = useAnimCounter(end, duration);
  return (
    <span ref={ref}>
      {prefix}{value}{suffix}
    </span>
  );
}
